import '../../style/base.css';
import '../../info/index.css';
import '../../sidebar-item/index.css';
import '../../icon/index.css';
import '../../sidebar/index.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/es/tree-select/style/index.js
// module id = z+oF
// module chunks = 0